import { IsIn, IsOptional, IsString } from 'class-validator';

export class GetReviewFiltersDto {
  @IsIn(['goal_management'])
  @IsString()
  @IsOptional()
  page?: 'goal_management';
}
